import config from "../config";

const baseUrl = () => config.url.replace(/\/$/, "");

function extractBlogFileName(imageUrl) {
  if (!imageUrl) return null;

  const normalized = imageUrl.replace(/^\/+/, "");
  if (!normalized) return null;

  return normalized.includes("/")
    ? normalized.substring(normalized.lastIndexOf("/") + 1)
    : normalized;
}

export function getBlogImageUrl(imageUrl) {
  if (!imageUrl) return null;
  if (imageUrl.startsWith("http://") || imageUrl.startsWith("https://")) {
    return imageUrl;
  }

  const fileName = extractBlogFileName(imageUrl);
  if (!fileName) return null;

  // Served via Spring Boot API so nginx /api proxy always works
  return `${baseUrl()}/api/blogs/media/${encodeURIComponent(fileName)}`;
}
